import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcPlace24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m6 21c0-.531.469-1 1-1h10c.531 0 1 .469 1 1s-.469 1-1 1h-10c-.531 0-1-.469-1-1zm6-19c3.406 0 6 2.563 6 5.625 0 1.156-.344 2.281-1.094 3.438l-4.062 6.468c-.219.313-.531.469-.844.469-.344 0-.625-.156-.844-.469l-4.062-6.437c-.719-1.156-1.094-2.314-1.094-3.469 0-3.063 2.563-5.625 6-5.625zm.031 2c-2.281 0-4.031 1.594-4.031 3.594 0 .75.25 1.531.781 2.375l3.219 5.031 3.219-5.031c.219-.313.781-1.188.781-2.344 0-2.031-1.719-3.625-3.969-3.625zm-2.031 4c0-1.094.906-2 2-2s2 .906 2 2-.906 2-2 2-2-.906-2-2z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcPlace24;
